import React from 'react';
import { __ } from '../../../translations';
import h from '../../../helpers/common';
import { useSelector } from 'react-redux';
// import { QitafButton } from '@intigral/ui';
import { Box, Text, FlexWrapper, FontIcon } from '@intigral/shared';
import withPresetWidth from '@intigral/shared/components/hocs/withPresetWidth/withPresetWidth';
import { useConfigurationSections } from '../../../hooks/useConfiguration';

const BoxWidth = withPresetWidth(Box);

const QitafBanner = ({ updatedPrice = 0, setShowQitafPopup, setUpdatedPrice, qitafApplied }) => {
    // Using React Query instead of Redux for configuration
    const { config } = useConfigurationSections();

    return (
        <>
            <BoxWidth theme="brand" paddingStart="3x" presetWidth="medium">
                <FlexWrapper flexDirection="row" justifyContent="between" alignItems="center">
                    <div>
                        <img src={config?.qitaf?.QitafLogo} alt="Qitaf by STC" style={{ display: 'block' }} />
                    </div>
                    <Text as="p" color="white" margin="0">
                        <a
                            onClick={() => {
                                setShowQitafPopup(true);
                                document.querySelector('.close-icon').style.display = 'none';
                            }}
                            style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                        >
                            {qitafApplied ? __(['qitaf_reset']) : __(['qitaf_apply'])}
                            <FontIcon name="arrow" rotate="flip" />
                        </a>
                    </Text>
                </FlexWrapper>
            </BoxWidth>
        </>
    );
};

export default QitafBanner;
